import { render, staticRenderFns } from "./PriceAndPaidModal.vue?vue&type=template&id=18ecfe86&scoped=true"
import script from "./PriceAndPaidModal.vue?vue&type=script&lang=js"
export * from "./PriceAndPaidModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ecfe86",
  null
  
)

export default component.exports